import { Pipe, PipeTransform } from '@angular/core';
import { OffsetDetectionStepId, formatOffsetDetectionStepValue } from 'motion-master-client';

@Pipe({ name: 'formatOffsetDetectionStepValue' })
export class FormatOffsetDetectionStepValuePipe implements PipeTransform {
  transform(value: any, stepId: OffsetDetectionStepId) {
    return formatOffsetDetectionStepValue(stepId, value);
  }
}
